import type { PersonRecord } from '@/data/schemas';

export type ContactSyncPayload = {
  contact: {
    id: string;
    companyId: string;
    siteId?: string;
    name: string;
    phone?: string;
    email?: string;
  };
  expectedUpdatedAt?: string | null;
};

export function buildContactName(person: PersonRecord): string {
  return `${person.firstName} ${person.lastName}`.trim();
}

export function buildContactSyncPayload(
  companyId: string,
  person: PersonRecord,
  expectedUpdatedAt?: string | null
): ContactSyncPayload {
  return {
    contact: {
      id: person.id,
      companyId,
      siteId: person.scope === 'site' ? person.siteId : undefined,
      name: buildContactName(person),
      phone: person.phone ?? undefined,
      email: person.email ?? undefined,
    },
    expectedUpdatedAt,
  };
}
